import { useResetRecoilState, useSetRecoilState } from 'recoil';

import { CustomerItemDataProps } from '../../pages/Consortium/utils/types';

import {
  customerConsortiumChannelsSelectedState,
  customerConsortiumItemSelectedState,
  customerConsortiumPlanSelectedState,
  customerConsortiumRadioSelectedState,
  customerConsortiumSectionStatusState,
} from './atom';
import {
  updateCustomerSectionStatus,
  updateCustomerItemSelected,
  updateCustomerConsortiumPlanSelected,
  updateCustomerConsortiumRadioSelectedOptionSelector,
  updateCustomerConsortiumChannelsSelectedSelector,
} from './selector';
import { CustomerPlanSelection, CustomerSectionStatus } from './types';

export const useConsortiumActions = () => {
  const setCustomerSectionStatus = useSetRecoilState(updateCustomerSectionStatus);
  const setCustomerItem = useSetRecoilState(updateCustomerItemSelected);
  const setCustomerConsortiumPlanSelected = useSetRecoilState(updateCustomerConsortiumPlanSelected);
  const setCustomerConsortiumRadioSelectedOption = useSetRecoilState(
    updateCustomerConsortiumRadioSelectedOptionSelector
  );
  const updateCustomerConsortiumChannelsSelected = useSetRecoilState(
    updateCustomerConsortiumChannelsSelectedSelector
  );

  const resetCustomerConsortiumSectionStatus = useResetRecoilState(
    customerConsortiumSectionStatusState
  );
  const resetCustomerConsortiumItemSelected = useResetRecoilState(
    customerConsortiumItemSelectedState
  );
  const resetCustomerConsortiumPlanSelected = useResetRecoilState(
    customerConsortiumPlanSelectedState
  );
  const resetCustomerConsortiumChannelsSelected = useResetRecoilState(
    customerConsortiumChannelsSelectedState
  );
  const resetCustomerConsortiumRadioSelected = useResetRecoilState(
    customerConsortiumRadioSelectedState
  );

  const updateCustomerStatus = (status: CustomerSectionStatus) => {
    setCustomerSectionStatus(status);
  };

  const handleSelectCustomerItem = (customer: CustomerItemDataProps) => {
    setCustomerItem(customer);
  };

  const handleSelectCustomerConsortiumPlan = (plan: CustomerPlanSelection) => {
    setCustomerConsortiumPlanSelected(plan);
  };

  const handleSelectCustomerConsortiumRadio = (option: string) => {
    setCustomerConsortiumRadioSelectedOption(option);
  };

  const handleSelectCustomerConsortiumChannels = (channels: string[]) => {
    updateCustomerConsortiumChannelsSelected(channels);
  };

  const handleResetCustomerConsortium = () => {
    resetCustomerConsortiumSectionStatus();
    resetCustomerConsortiumItemSelected();
    resetCustomerConsortiumPlanSelected();
    resetCustomerConsortiumChannelsSelected();
    resetCustomerConsortiumRadioSelected();
  };

  return {
    handleSelectCustomerConsortiumPlan,
    updateCustomerStatus,
    handleSelectCustomerItem,
    handleSelectCustomerConsortiumRadio,
    handleSelectCustomerConsortiumChannels,
    handleResetCustomerConsortium,
  };
};
